
<div class="compare__body">
  <app-online-view-table [columns]="columns"></app-online-view-table>
</div>

<ng-template #offlineStaff let-row="row">
  @if (row['cnt_staff_offline']) {
    <a href="javascript:void(0)" (click)="displayStaff(row)">
      {{row['cnt_staff_offline']}}
    </a>
  }
  @if (!row['cnt_staff_offline']) {
    <span>{{row['cnt_staff_offline']}}</span>
  }
</ng-template>

<ng-template #onlineStaff let-row="row">
  @if (row['cnt_staff_online']) {
    <a href="javascript:void(0)" (click)="displayStaffOnline(row)">
      {{row['cnt_staff_online']}}
    </a>
  }
  @if (!row['cnt_staff_online']) {
    <span>{{row['cnt_staff_online']}}</span>
  }
</ng-template>

<ng-template #allStaff let-row="row">
  @if (row['cnt_staff']) {
    <a href="javascript:void(0)" (click)="displayAllStaff(row)">
      {{row['cnt_staff']}}
    </a>
  }
  @if (!row['cnt_staff']) {
    <span>{{row['cnt_staff']}}</span>
  }
</ng-template>
